import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';

/**
 * Warmup settings used to be a page of its own at this path; it is now the
 * "Warmup settings" tab on the account detail page. The route survives only as
 * a redirect so existing links and bookmarks keep working. `replace: true`
 * keeps the old URL out of the browser history. Auth is enforced by the
 * detail route it lands on.
 *
 * `beforeLoad` throws ahead of the component, so `component` is never invoked
 * at runtime — TanStack Router still requires the prop (same shape as
 * `routes/index.tsx`).
 */
export const emailAccountWarmupSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/email-accounts/$id/warmup-settings',
  parseParams: (params) => ({ id: Number(params.id) }),
  stringifyParams: (params) => ({ id: String(params.id) }),
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/email-accounts/$id',
      params: { id: params.id },
      search: { tab: 'warmup-settings' },
      replace: true,
    });
  },
  component: () => null,
});
